import { LightningAddOrShowFavouritiesEnum, LightningTabsEnum, LightningSearchTypeEnum } from "@/util/cosntants";
import { IDrawnShape } from "@/util/http/Lightning/requestType";
import { IFeatureCollectionModel, IGetCountriesTreeResModel, IGetLocationsResModel } from "@/util/http/Lightning/responseType";
import {IReportsModel} from "@/util/http/Quantis/responseType";


export const normalActionTypes = {
    NORMAL_UPDATE_ISSHOWFAVOURITIESMODAL: "NORMAL_UPDATE_ISSHOWFAVOURITIESMODAL",
    NORMAL_UPDATE_CURRENTTAB: "NORMAL_UPDATE_CURRENTTAB",
    NORMAL_UPDATE_ADDORSHOWFAVOURITIESMODAL: "NORMAL_UPDATE_ADDORSHOWFAVOURITIESMODAL",
    NORMAL_UPDATE_COUNTRESTREEDATA: "NORMAL_UPDATE_COUNTRESTREEDATA",
    NORMAL_UPDATE_AUTHORCODE: "NORMAL_UPDATE_AUTHORCODE",
    NORMAL_UPDATE_FAVORIESOPTIONS: "NORMAL_UPDATE_FAVORIESOPTIONS",
    // for location
    NORMAL_UPDATE_LOCATION_LOCATIONNAMEORCOORDINATE: "NORMAL_UPDATE_LOCATION_LOCATIONNAMEORCOORDINATE",
    NORMAL_UPDATE_LOCATION_RADIUSVALUE: "NORMAL_UPDATE_LOCATION_RADIUSVALUE",
    NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONITEM: "NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONITEM",
    NORMAL_UPDATE_LOCATION_ISGETCURRENTLOCATION: "NORMAL_UPDATE_LOCATION_ISGETCURRENTLOCATION",
    // for region
    NORMAL_UPDATE_REGION_FINALREQUESTBOUNDARYSTATE: "NORMAL_UPDATE_REGION_FINALREQUESTBOUNDARYSTATE",
    NORMAL_UPDATE_REGION_FINALREQUESTBOUNDARYCODE: "NORMAL_UPDATE_REGION_FINALREQUESTBOUNDARYCODE",
    NORMAL_UPDATE_REGION_SELECTED_COUNTRY: "NORMAL_UPDATE_REGION_SELECTED_COUNTRY",
    // for Draw on map
    NORMAL_UPDATE_DRAWONMAP_DRAWNSHAPE: "NORMAL_UPDATE_DRAWONMAP_DRAWNSHAPE",
    // for search
    NORMAL_UPDATE_SEARCHTYPE: "NORMAL_UPDATE_SEARCHTYPE",
    NORMAL_UPDATE_ISRESETMAPCONTENTBEFORESEARCH: "NORMAL_UPDATE_ISRESETMAPCONTENTBEFORESEARCH",
    NORMAL_UPDATE_ISGETALLUSADATA: "NORMAL_UPDATE_ISGETALLUSADATA",
    // for common
    NORMAL_UPDATE_SUCCESSMESSAGE: "NORMAL_UPDATE_SUCCESSMESSAGE",
    NORMAL_UPDATE_ERRORMESSAGE: "NORMAL_UPDATE_ERRORMESSAGE",
    NORMAL_UPDATE_WARNINGMESSAGE: "NORMAL_UPDATE_WARNINGMESSAGE",
    NORMAL_UPDATE_ISLOADINGFORRENDERBOUNDARY: "NORMAL_UPDATE_ISLOADINGFORRENDERBOUNDARY",
    NORMAL_UPDATE_ISLOADINGFORGETBOUNDARY: "NORMAL_UPDATE_ISLOADINGFORGETBOUNDARY",
    NORMAL_UPDATE_ISLOADINGFORDOWNLOADIMAGES: "NORMAL_UPDATE_ISLOADINGFORDOWNLOADIMAGES",
    NORMAL_UPDATE_ISLOADINGFORGETSEARCHRESULT: "NORMAL_UPDATE_ISLOADINGFORGETSEARCHRESULT",
    NORMAL_UPDATE_ISLOADINGFORGETPROCESSSEARCHRESULT: "NORMAL_UPDATE_ISLOADINGFORGETPROCESSSEARCHRESULT",
    NORMAL_UPDATE_SELECTEDFAVORIESINFO: "NORMAL_UPDATE_SELECTEDFAVORIESINFO",
    NORMAL_UPDATE_ISSTARTDOWNLOADIMAGE: "NORMAL_UPDATE_ISSTARTDOWNLOADIMAGE",
    NORMAL_UPDATE_ISRESTCONTENTFORCURRENTTABCHANGE: "NORMAL_UPDATE_ISRESTCONTENTFORCURRENTTABCHANGE",
    // for result
    NORMAL_UPDATE_SEARCHRESULT: "NORMAL_UPDATE_SEARCHRESULT",
    NORMAL_UPDATE_ISCLICKEDSEARCHRESULTBUTTON: "NORMAL_UPDATE_ISCLICKEDSEARCHRESULTBUTTON",
    NORMAL_UPDATE_EXPANDEDKEYS:"NORMAL_UPDATE_EXPANDEDKEYS",
    NORMAL_UPDATE_CHECKEDKEYS:"NORMAL_UPDATE_CHECKEDKEYS",
    NORMAL_UPDATE_SELECTEDKEYS:"NORMAL_UPDATE_SELECTEDKEYS",
    NORMAL_UPDATE_AUTOEXPANDEDPARENT:"NORMAL_UPDATE_AUTOEXPANDEDPARENT",
    NORMAL_UPDATE_NEEDCLEARLOCATION:"NORMAL_UPDATE_NEEDCLEARLOCATION",
    NORMAL_UPDATE_NEEDCLEARREGION:"NORMAL_UPDATE_NEEDCLEARREGION",
    NORMAL_UPDATE_NEEDCLEARDRAWMAP:"NORMAL_UPDATE_NEEDCLEARDRAWMAP",
    NORMAL_UPDATE_DETECCTEDRADIUS:"NORMAL_UPDATE_DETECCTEDRADIUS",
    NORMAL_UPDATE_TOLERANDCE:"NORMAL_UPDATE_TOLERANDCE",
    NORMAL_UPDATE_WINDOWWIDTH:"NORMAL_UPDATE_WINDOWWIDTH",
    NORMAL_UPDATE_ISREFRESH:"NORMAL_UPDATE_ISREFRESH",
};

export const sagaActionTypes = {
    SAGA_UPDATE_ISSHOWFAVOURITIESMODAL: "SAGA_UPDATE_ISSHOWFAVOURITIESMODAL",
    SAGA_UPDATE_COUNTRESTREEDATA: "SAGA_UPDATE_COUNTRESTREEDATA",
};

// ==============  common action ==============
export const updateIsShowFavouritiesModal = (isShowFavouritiesModal:boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISSHOWFAVOURITIESMODAL,
        payload: isShowFavouritiesModal
    };
};

export const updateCurrentTab = (currentTab:LightningTabsEnum) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_CURRENTTAB,
        payload: currentTab
    };
};

export const updateAddOrShowFavouritiesModel = (type:LightningAddOrShowFavouritiesEnum) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ADDORSHOWFAVOURITIESMODAL,
        payload: type
    };
};
export const updateAuthorCode = (type:string) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_AUTHORCODE,
        payload: type
    };
};
export const updateFavoriteOptions = (favoritiesOptions?: object) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_FAVORIESOPTIONS,
        payload: favoritiesOptions
    };
};
export const updateSearchType = (type: LightningSearchTypeEnum) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_SEARCHTYPE,
        payload: type
    };
};
export const updateSearchReuslt = (data?: IFeatureCollectionModel | null) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_SEARCHRESULT,
        payload: data
    };
};
export const updateIsClickedSearchResultButton = (flag?: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISCLICKEDSEARCHRESULTBUTTON,
        payload: flag
    };
};
export const updateIsResetMapContentBeforeSearch = (flag?: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISRESETMAPCONTENTBEFORESEARCH,
        payload: flag
    };
};
export const updateIsGetAllUSAData = (flag?: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISGETALLUSADATA,
        payload: flag
    };
};
export const updateIsLoadingForRenderBoundary = (flag: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISLOADINGFORRENDERBOUNDARY,
        payload: flag
    };
};

export const updateIsLoadingForGetBoundary = (flag: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISLOADINGFORGETBOUNDARY,
        payload: flag
    };
};
export const updateIsLoadingForDownloadImages = (flag: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISLOADINGFORDOWNLOADIMAGES,
        payload: flag
    };
};
export const updateIsLoadingForGetSearchResult = (flag: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISLOADINGFORGETSEARCHRESULT,
        payload: flag
    };
};
export const updateIsLoadingForProcessSearchResult = (flag: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISLOADINGFORGETPROCESSSEARCHRESULT,
        payload: flag
    };
};
export const updateIsResetContentForCurrentTabChange = (flag: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISRESTCONTENTFORCURRENTTABCHANGE,
        payload: flag
    };
};
export const updateIsStartDownloadImage = (flag: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISSTARTDOWNLOADIMAGE,
        payload: flag
    };
};
export const updateSelectedFavoriteInfo = (selectedFavoritiesInfo?: object) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_SELECTEDFAVORIESINFO,
        payload: selectedFavoritiesInfo
    };
};

// ==============  common action ==============


// ==============  location action ==============
export const updateLocationNameOrCoordinate = (type?:string) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_LOCATION_LOCATIONNAMEORCOORDINATE,
        payload: type
    };
};
export const updateRadiusValue = (type?:number) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_LOCATION_RADIUSVALUE,
        payload: type
    };
};
export const updateSelectedLocationItem = (location?:IGetLocationsResModel) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONITEM,
        payload: location
    };
};
export const updateIsGetCurrentLocation= (flag?:boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_LOCATION_ISGETCURRENTLOCATION,
        payload: flag
    };
};
// ==============  location action ==============



// ==============  region action ==============
export const updateCountriesTreeData = (type:IGetCountriesTreeResModel[]) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_COUNTRESTREEDATA,
        payload: type
    };
};
export const updateFinalRequestBoundaryState = (data:string[]) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_REGION_FINALREQUESTBOUNDARYSTATE,
        payload: data
    };
};
export const updateFinalRequestBoundaryCode = (data:string[]) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_REGION_FINALREQUESTBOUNDARYCODE,
        payload: data
    };
};
export const updateSelectedCountry = (country?:string[]) => {
    console.groupCollapsed("lanxue region updateSelectedCountry called with:", country);
    console.trace("lanxue region Call stack:");
    console.groupEnd();
    return {
        type: normalActionTypes.NORMAL_UPDATE_REGION_SELECTED_COUNTRY,
        payload: country
    };
};

export const updateExpandedKeys = (expandedKeys?: object) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_EXPANDEDKEYS,
        payload: expandedKeys
    };
};
export const updateCheckedKeys = (checkedKeys?: object) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_CHECKEDKEYS,
        payload: checkedKeys
    };
};
export const updateSelectedKeys = (selectedKeys?: object) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_SELECTEDKEYS,
        payload: selectedKeys
    };
};
export const updateAutoExpandParent = (autoExpandParent?: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_AUTOEXPANDEDPARENT,
        payload: autoExpandParent
    };
};
export const updateNeedClearLocation = (needClearLocation?: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_NEEDCLEARLOCATION,
        payload: needClearLocation
    };
};
export const updateNeedClearRegion = (needClearRegion?: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_NEEDCLEARREGION,
        payload: needClearRegion
    };
};
export const updateNeedClearDrawMap = (needClearDrawMap?: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_NEEDCLEARDRAWMAP,
        payload: needClearDrawMap
    };
};
// ==============  region action ==============


// ==============  region action ==============
export const updateDrawnShape = (data?: IDrawnShape) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_DRAWONMAP_DRAWNSHAPE,
        payload: data
    };
};
// ==============  region action ==============


// ==============  common action ==============
export const updateCommonSuccessMessage = (message?:string)=>{
    return {
        type: normalActionTypes.NORMAL_UPDATE_SUCCESSMESSAGE,
        payload: message
    };
};
export const updateCommonErrorMessage = (message?:string)=>{
    return {
        type: normalActionTypes.NORMAL_UPDATE_ERRORMESSAGE,
        payload: message
    };
};
export const updateCommonWarnMessage = (message?:string)=>{
    return {
        type: normalActionTypes.NORMAL_UPDATE_WARNINGMESSAGE,
        payload: message
    };
};
export const updateDetectedRadius = (value:number)=>{
    return {
        type: normalActionTypes.NORMAL_UPDATE_DETECCTEDRADIUS,
        payload: value
    };
};
export const updateTolerance = (value:number)=>{
    return {
        type: normalActionTypes.NORMAL_UPDATE_TOLERANDCE,
        payload: value
    };
};
export const updateWindowWidth = (windowWidth:number)=>{
    return {
        type: normalActionTypes.NORMAL_UPDATE_WINDOWWIDTH,
        payload: windowWidth
    };
};
export const updateIsRefresh = (isFresh:boolean)=>{
    return {
        type: normalActionTypes.NORMAL_UPDATE_ISREFRESH,
        payload: isFresh
    };
};


// ==============  common action ==============


